// removed by extract-text-webpack-plugin
module.exports = {"display":"_3qQmX","device":"btVVx","speaker":"_3mXbo","phone":"_3ec3k"};